import { usePermissions } from './usePermissions';

export function useAccountAccess() {
  const { can, isAdmin } = usePermissions();

  const canEditAccounts = can('manage_accounts') || isAdmin;
  const canViewBalance = true; // Tout le monde peut voir la balance

  return {
    canEditAccounts,
    canViewBalance
  };
}